import AuthenticationRepository from './AuthenticationRepository.js'

/**
 * @implements Repository
 * This repository creates cookies that are legacy, and should not be used for new developments.
 * Check CookieAuthenticationRepository to see what cookies should be used.
 */
export default class LegacyCookieAuthenticationRepository extends AuthenticationRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {JsCookie} deps.cookieManager
   * @param {String} deps.site
   */
  constructor({cookieManager, config}) {
    super()
    this._cookieManager = cookieManager
    this._config = config
    this._site = this._config.get('ID')
    this._LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS = this._config.get('login').LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS
    this._SECURE_COOKIES = this._config.get('SECURE_COOKIES')
  }

  /**
   * @param {Object} params
   * @param {SessionAuthenticationValueObject} params.sessionAuthenticationValueObject
   * @return {Promise<void>}
   */
  setUserData({sessionAuthenticationValueObject}) {
    if (this._site === 'motos') {
      const today = new Date()
      this._cookieManager.set(
        'userGTAinfo',
        sessionAuthenticationValueObject.getUserData().getName() +
          '#' +
          today.getDate() +
          '/' +
          today.getMonth() +
          '/' +
          today.getFullYear(),
        {
          expires: this._LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS,
          secure: this._SECURE_COOKIES
        }
      )
    }

    if (this._site === 'coches') {
      this._cookieManager.set('LogUser', sessionAuthenticationValueObject.getLogUser().toJSON(), {
        expires: this._LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS,
        secure: this._SECURE_COOKIES
      })
    }

    return Promise.resolve()
  }
}
